module.exports = __webpack_public_path__ + "img/D201607_1.0d6b51f3.jpg";